import { render, staticRenderFns } from "./CertificatesActivateModal.vue?vue&type=template&id=032bd1e0&"
import script from "./CertificatesActivateModal.vue?vue&type=script&lang=js&"
export * from "./CertificatesActivateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports